<template>
  <div id="app">
    <component :is="activeAuth" :secret="secret"></component>
  </div>
</template>

<script>

  import Main from "./views/Main";
  import Login from "./views/Login";
  import firebase from "firebase";
  import {eventBus} from "./eventbus";

  export default {
    name: 'App',
    components: {
      Main,
      Login
    },
    data: () => ({
      activeAuth: 'Login',
      secret: ''
    }),
    created() {
      this.getKeys()
      this.listener()
    },
    methods: {
      getKeys() {
        let keys = []
        firebase.database().ref('secret_word/1').once('value', snapshot => {
          let key = {key: snapshot.key}
          let value = snapshot.val()
          keys.push({key, value})
        })
        this.secret = keys
      },
      listener() {
        eventBus.$on('Main', () => this.activeAuth = "Main")
        eventBus.$on('Login', () => this.activeAuth = "Login")
      }
    }
  }
</script>


<style>
  @import url('https://fonts.googleapis.com/css?family=Lato|Poppins&display=swap');

  #app {
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
  }

  .lato {
    font-family: 'Lato', sans-serif;
  }

  .poppins {
    font-family: 'Poppins', sans-serif;
  }

  body {
    background-color: #e4daf6 !important;

  }
</style>
